import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=1cb20f7f"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports